import { useEffect, useState } from "react";
import { RequestState } from "../../../../constants/request-state";
import { InventoryDealerUpdate } from "../../../../types/inventory/updates-by-dealer/InventoryDealerUpdate";
import { isRequestNone } from "../../../../utils/request-state.utils";
import { inventoryService } from "../../../../services/inventory.service";
import { useAppDispatch } from "../../../../effects/useAppDispatch";

export function useInventoryByDealerUpdates() {
    const dispatch = useAppDispatch();

    const [requestState, setRequestState] = useState(RequestState.none);
    const [dealerUpdates, setDealerUpdates] = useState<InventoryDealerUpdate[]>([]);

    useEffect(() => {
        if (!isRequestNone(requestState)) return;

        const doRequest = async () => {
            setRequestState(RequestState.request);
            try {
                const dealerUpdates = await inventoryService.getInventoryByDealerUpdates();
                setDealerUpdates(dealerUpdates);
                setRequestState(RequestState.success);
            } catch (error) {
                setRequestState(RequestState.failure);
            }
        }

        doRequest();
    }, [requestState, dispatch]);

    return { requestState, dealerUpdates };
}